export default "__VITE_ASSET__b9sw_J$y__"